import { IPaginateCardProps } from "@/interfaces/Card";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import { Button, FormControl, InputGroup } from "react-bootstrap";
import classNames from "classnames";
import Flex from "@/components/atoms/Flex";
import TablePagination from "../table/TablePagination";

const PaginateCard: FC<IPaginateCardProps> = ({
  meta = { currentPage: 1, lastPage: 1, firstPage: 1 },
  children,
  title,
  card = false,
  filters,
  setFilters,
  headerActions,
}) => {
  const nextPage = () =>
    setFilters((old) => ({ ...old, pageIndex: old.pageIndex! + 1 }));

  const previousPage = () =>
    setFilters((old) => ({ ...old, pageIndex: old.pageIndex! - 1 }));

  const setPageIndex = (pageIndex: number) =>
    setFilters((old) => ({ ...old, pageIndex }));

  const canNextPage = () => meta.currentPage !== meta.lastPage;

  const canPreviousPage = () => meta.firstPage !== meta.currentPage;

  return (
    <div
      className={classNames({
        card: card,
      })}
    >
      <div
        className={classNames({
          "card-header d-flex justify-content-between align-items-center mb-1 mb-md-0 flex-wrap":
            card,
        })}
      >
        {title && <h5>{title}</h5>}
        <div className="d-flex gap-2 align-items-center justify-content-between mb-3">
          <InputGroup
            className={classNames("position-relative input-search-width", {
              "mb-3": !card && !headerActions,
            })}
          >
            <FormControl
              size="sm"
              id="search"
              type="search"
              className="shadow-none"
              placeholder="Rechercher"
              onChange={(e) =>
                setFilters((old) => ({ ...old, query: e.target.value }))
              }
            />
            <Button
              size="sm"
              variant="outline-secondary"
              className="border-300 hover-border-secondary"
            >
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup>
          {headerActions}
        </div>
      </div>
      <Flex
        direction="column"
        className={classNames({
          "card-body p-0": card,
          "gap-3": !card,
        })}
      >
        {children}
      </Flex>
      <div
        className={classNames({
          "card-footer": card,
        })}
      >
        <TablePagination
          className={classNames({
            "mt-2": card,
            "mt-4": !card,
          })}
          nextPage={nextPage}
          pageCount={meta.lastPage}
          pageIndex={filters.pageIndex!}
          previousPage={previousPage}
          setPageIndex={setPageIndex}
          canNextPage={canNextPage()}
          canPreviousPage={canPreviousPage()}
        />
      </div>
    </div>
  );
};

export default PaginateCard;
